import { UIButton, UIColor, UITextView } from "uicore-ts"
import { RHButtons, RHFont, RHShadow } from "../Custom components/RH/Utils_slop/RHDesignTokens"
import { RHLoginViewTokens } from "../Custom components/RH/Utils_slop/RHViewTokens"

export class MicrosoftLoginButton extends UIButton {
    
    private static readonly _logoSource = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMSAyMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIGZpbGw9IiNGMjUwMjIiLz48cmVjdCB4PSIxMSIgeT0iMCIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjN0ZCQTAwIi8+PHJlY3QgeD0iMCIgeT0iMTEiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgZmlsbD0iIzAwQTRFRiIvPjxyZWN0IHg9IjExIiB5PSIxMSIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSIjRkZCOTAwIi8+PC9zdmc+"
    
    private static readonly _fillColor = new UIColor("#ffffff")
    private static readonly _fillColorHovered = new UIColor("#f2f2f2")
    private static readonly _fillColorHighlighted = new UIColor("#e8e8e8")
    private static readonly _textColor = new UIColor("#1f1f1f")
    
    constructor(elementID?: string) {
        
        super(elementID, "button")
        
        this.imageView.imageSource = MicrosoftLoginButton._logoSource
        this.imageView.hidden = false
        
        this.titleLabel.configureWithObject({
            text: "Logi sisse Microsoftiga",
            textAlignment: UITextView.textAlignment.left,
            style: {
                // fontFamily: "'Segoe UI', sans-serif",
                fontFamily: RHFont.familyBase,
                fontWeight: "600",
                // fontSize: "14px",
                fontSize: RHLoginViewTokens.oauthButtonLabelFontSize,
                color: MicrosoftLoginButton._textColor.stringValue,
                whiteSpace: "nowrap"
            }
        })
        
        this.configureWithObject({
            // @ts-ignore
            style: {
                boxSizing: "border-box",
                backgroundColor: MicrosoftLoginButton._fillColor.stringValue,
                border: "1px solid #8c8c8c",
                // borderRadius: "4px",
                borderRadius: RHButtons.borderRadius,
                cursor: "pointer",
                overflow: "hidden",
                transition: "background-color 0.1s ease, box-shadow 0.1s ease"
            }
        })
        
        this.colors = {
            titleLabel: {
                normal: MicrosoftLoginButton._textColor,
                highlighted: MicrosoftLoginButton._textColor,
                selected: MicrosoftLoginButton._textColor,
                hovered: MicrosoftLoginButton._textColor,
                focused: MicrosoftLoginButton._textColor
            },
            background: {
                normal: MicrosoftLoginButton._fillColor,
                hovered: MicrosoftLoginButton._fillColorHovered,
                highlighted: MicrosoftLoginButton._fillColorHighlighted,
                focused: MicrosoftLoginButton._fillColorHovered,
                selected: MicrosoftLoginButton._fillColor
            }
        }
        
        this.updateContentForNormalState()
        
    }
    
    override updateContentForNormalState() {
        super.updateContentForNormalState()
        this.style.backgroundColor = MicrosoftLoginButton._fillColor.stringValue
        // this.style.boxShadow = "0 1px 2px rgba(0,0,0,0.12)"
        this.style.boxShadow = RHShadow.subtle
    }
    
    override updateContentForHoveredState() {
        super.updateContentForHoveredState()
        this.style.backgroundColor = MicrosoftLoginButton._fillColorHovered.stringValue
        // this.style.boxShadow = "0 1px 3px rgba(0,0,0,0.18)"
        this.style.boxShadow = RHShadow.medium
    }
    
    override updateContentForFocusedState() {
        super.updateContentForFocusedState()
        this.style.backgroundColor = MicrosoftLoginButton._fillColorHovered.stringValue
        this.style.boxShadow = "0 0 0 3px rgba(0,120,212,0.3)"
    }
    
    override updateContentForHighlightedState() {
        super.updateContentForHighlightedState()
        this.style.backgroundColor = MicrosoftLoginButton._fillColorHighlighted.stringValue
        // this.style.boxShadow = "0 1px 2px rgba(0,0,0,0.12)"
        this.style.boxShadow = RHShadow.subtle
    }
    
    
    override layoutSubviews() {

        const bounds = this.bounds
        const logoSize = 20
        const logoToTextGap = 12

        // Center the logo + label as a single group within the button (instead of pinning it
        // to the left edge), so the wide button reads as intentional and balanced.
        const titleWidth = this.titleLabel.intrinsicContentWidth(bounds.height)
        const groupWidth = logoSize + logoToTextGap + titleWidth
        const groupLeft = [(bounds.width - groupWidth) * 0.5, 0].max()

        this.imageView.style.left = groupLeft + "px"
        this.imageView.style.width = logoSize + "px"
        this.imageView.style.height = logoSize + "px"
        this.imageView.style.top = (bounds.height - logoSize) * 0.5 + "px"

        this.titleLabel.style.left = (groupLeft + logoSize + logoToTextGap) + "px"
        this.titleLabel.style.right = "auto"
        this.titleLabel.style.width = (titleWidth + RHLoginViewTokens.oauthButtonLabelSafetyBuffer) + "px"
        this.titleLabel.style.top = "50%"
        this.titleLabel.style.transform = "translateY(-50%)"

    }
    
}
